<template>
  <div>
    <CCard style="margin-top: 20px">
      <CCol xs="6" lg="6" style="margin-top: 20px">
        <select v-model="gameName" class="form-control sl">
          <option v-for="game in gameList" v-bind:key="game.id">
            {{ game.name }}
          </option>
        </select>
      </CCol>
      <CCol xs="12" lg="12" style="margin-top: 20px">
        <CTabs variant="pills">
          <CTab :title="gameName + ' claimed Points'" active>
            <hr />
            <NewGameClaimed :name="gameName"></NewGameClaimed>
          </CTab>
          <CTab :title="gameName + ' unclaimed Points'">
            <hr />
            <NewGameUnclaimed :name="gameName"></NewGameUnclaimed>
          </CTab>
          <CTab :title="gameName + ' Points Entry'">
            <hr />
            <NewGamePointEntry :name="gameName"></NewGamePointEntry>
          </CTab>
          <CTab :title="gameName + ' Daily Limit'">
            <hr />
            <NewGameDailyLimit :name="gameName"></NewGameDailyLimit>
          </CTab>
        </CTabs>
      </CCol>
    </CCard>
  </div>
</template>
<style src="spinkit/spinkit.min.css"></style>
<script>
import firebase from "firebase";
import NewGamePointEntry from "./newGamePointsEntry.vue";
import NewGameClaimed from "./newGameClaimed.vue";
import NewGameDailyLimit from "./newGameDailyLimit.vue";
import NewGameUnclaimed from "./newGameUnclaimed.vue";
const db = firebase.firestore();
export default {
  components: {
    NewGamePointEntry,
    NewGameClaimed,
    NewGameDailyLimit,
    NewGameUnclaimed,
  },
  data() {
    return {
      activeTab: 1,
      value1: [],
      gameName: "snake",
      gameList: [
        { id: 1, name: "snake" },
        { id: 2, name: "tower game" },
        { id: 3, name: "carrom" },
        { id: 4, name: "dunkmaster" },
      ],
    };
  },
  created() {
    let self = this;
    // console.log(self.gameList, "gameList Before");
    db.collection("gamesList")
      .doc("1")
      .get()
      .then((snapshot) => {
        if (snapshot.exists) {
          let gameListFromDB = snapshot.data().data;
          self.gameList = [];
          for (let i = 0; i < gameListFromDB.length; i++) {
            self.gameList.push({
              id: i,
              name: gameListFromDB[i],
            });
          }
          // console.log("gameList From Db", gameListFromDB);
          // console.log(self.gameList, "gameList");
        }
      });
  },
};
</script>

<style>
</style>